/** root url */
export const AppURL = {
    account: 'account',
    authen: 'authen',
    setting: 'setting',
    tax_invoice: 'tax-invoice',
};